import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { SCREEN_PATHS } from "../../../constants";
import { useAuthContext } from "../../../AuthContextWrapper";
import { AtticusScreenFlow } from "../../../models/AtticusScreenFlow";

interface Props {
  flow: AtticusScreenFlow;
}

export const FlowScreenLoader = ({ flow }: Props): JSX.Element => {
  const navigate = useNavigate();
  const { setFlow } = useAuthContext()
  const { screenName } = useParams();
  const [screenData, setScreenData] = useState<
    Record<string, string | number | boolean> | undefined[]
  >();

  const currentScreen = flow.getCurrentFlowScreen(screenName);

  useEffect(() => {
    if (!screenName) {
      // redirect to flow first screen as needed
      const firstScreenPath = flow.getFlowFirstScreen();
      navigate(firstScreenPath, {
        replace: true,
      });
    } else if (!currentScreen) {
      // redirect to 404
      navigate(SCREEN_PATHS.not_found);
    } else if (setFlow) {
      // set the flow globally so nav can update
      setFlow(flow);
    }
    // TODO: decide if the screenData is still needed
    // (async () => {
    //   // if screen definition has data property auto-load it and pass it to the component
    //   if (currentScreen?.data) {
    //     // assumes data being load is associated with authed users id (implied by "me")
    //     setScreenData(await flow.loadData(currentScreen, "me"));
    //   } else {
    //     setScreenData({ ready: true }); // set any value in screenData
    //   }
    // })();
    return () => setScreenData(undefined); // clean up between screens
  }, [currentScreen?.name]);

  return currentScreen ? (
    React.cloneElement(currentScreen?.screenComponent, {
      screenData,
    })
  ) : (
    <></>
  );
};
